/**
 * @file Handles browser window-related operations.
 * */
import getCsrfToken from 'bits/csrf_token'
import device from 'bits/device'
import window, { ww } from 'bits/global'

export function reload(): void {
  window.location.reload()
}

/**
 * Returns current browser url. Returns with query string by default.
 *
 * @param withQueryString Set to true by default
 */
export function currentUrl(options: { withQueryString: boolean } = { withQueryString: true }): string {
  return options.withQueryString ? window.location.href : window.location.href.split('?')[0]
}

export function currentPath(): string {
  return window.location.pathname
}

export function currentHostWithProtocol(): string {
  return `${window.location.protocol}//${window.location.host}`
}

export function buildUrlFromPath(path: string): string {
  const url = new URL(path, currentHostWithProtocol())
  return url.toString()
}

interface RedirectOptions {
  method?: string
  target?: string
}

export function navigateTo(url: string, options: RedirectOptions = {}): void {
  const { method, target } = options

  if (method && method.toLowerCase() !== 'get') {
    const fakeForm = document.createElement('form')

    const csrfTokenInput = document.createElement('input')
    csrfTokenInput.type = 'hidden'
    csrfTokenInput.name = 'authenticity_token'
    csrfTokenInput.value = getCsrfToken()

    const submitButton = document.createElement('button')
    submitButton.type = 'submit'

    fakeForm.action = url
    fakeForm.method = method
    fakeForm.appendChild(csrfTokenInput)
    fakeForm.appendChild(submitButton)
    document.body.appendChild(fakeForm)
    fakeForm.submit()
  } else if (device.desktopApp) {
    ww.navigateDesktopApp && ww.navigateDesktopApp(url, target)
  } else if (target) {
    window.open(url, target)
  } else {
    window.location.href = url
  }
}

export function navigateToMap({ lat, lng, name }: { lat: number; lng: number; name: string }): void {
  const searchQuery = name ? encodeURIComponent(name) : `${lat},${lng}`
  if (device.ios) {
    window.open(`http://maps.apple.com/?q=${searchQuery}&sll=${lat},${lng}`)
  } else {
    window.open('https://www.google.com/maps/search/?api=1&query=' + searchQuery)
  }
}
